import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForcedFlowAirCooler = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 70,
	height: 30,
	viewBox: "0 0 70.0 30.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 70,
			height: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 23.0 26.0 L 47.0 20.0 A 3.0 3.0 0.0 1 1 47.0 26.0 L 23.0 20.0 A 3.0 3.0 0.0 1 0 23.0 26.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 10.0 0.0 L 10.0 15.0 L 5.0 30.0 M 60.0 0.0 L 60.0 15.0 L 65.0 30.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgForcedFlowAirCooler;
